

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class SupportShiftReport_ManagedObject

class SupportShiftReport_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: employeeName
    set employeeName(value:string) {
        this.setValueForKey(value, 'employeeName');
    }
    get employeeName():string {
        return this.valueForKey('employeeName');
    }
    set employeeNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'employeeName');
    }
    get employeeNamePrimitiveValue():string {
        return this.primitiveValueForKey('employeeName');
    }

    // Property: shiftDate
    set shiftDate(value:Date) {
        this.setValueForKey(value, 'shiftDate');
    }
    get shiftDate():Date {
        return this.valueForKey('shiftDate');
    }
    set shiftDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'shiftDate');
    }
    get shiftDatePrimitiveValue():Date {
        return this.primitiveValueForKey('shiftDate');
    }

    // Property: signedAt
    set signedAt(value:Date) {
        this.setValueForKey(value, 'signedAt');
    }
    get signedAt():Date {
        return this.valueForKey('signedAt');
    }
    set signedAtPrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'signedAt');
    }
    get signedAtPrimitiveValue():Date {
        return this.primitiveValueForKey('signedAt');
    }

    // Property: signedByName
    set signedByName(value:string) {
        this.setValueForKey(value, 'signedByName');
    }
    get signedByName():string {
        return this.valueForKey('signedByName');
    }
    set signedByNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'signedByName');
    }
    get signedByNamePrimitiveValue():string {
        return this.primitiveValueForKey('signedByName');
    }

    // Property: summaryText
    set summaryText(value:string) {
        this.setValueForKey(value, 'summaryText');
    }
    get summaryText():string {
        return this.valueForKey('summaryText');
    }
    set summaryTextPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'summaryText');
    }
    get summaryTextPrimitiveValue():string {
        return this.primitiveValueForKey('summaryText');
    }
    // Relationship: employee
    set employee(value:Employee) {
        this.setValueForKey(value, 'employee');
    }
    get employee():Employee {
        return this.valueForKey('employee') as Employee;
    }
    // Relationship: pdfFile
    set pdfFile(value:FileAttachment) {
        this.setValueForKey(value, 'pdfFile');
    }
    get pdfFile():FileAttachment {
        return this.valueForKey('pdfFile') as FileAttachment;
    }

    // Relationship: tickets
    protected _tickets:MIOManagedObjectSet = null;
    get tickets():MIOManagedObjectSet {
        return this.valueForKey('tickets');
    }
    addTicketsObject(value:SupportTicket) {
        this._addObjectForKey(value, 'tickets');
    }
    removeTicketsObject(value:SupportTicket) {
        this._removeObjectForKey(value, 'tickets');
    }
}
